'use strict';
export default {
  methods: {
    contrastarSegip (params) {
      return new Promise((resolve, reject) => {
        this.$service
        .post(`djbr_registro/contrastacion_segip`, params)
        .then(response => {
          if (response) {
            resolve(response);
          } else {
            resolve({
              finalizado: false
            });
          }
        })
        .catch(e => {
          console.log(e);
          resolve({
            finalizado: false
          });
        });
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/djbrd/mixins/segip.js